export const language = {
	name: 'Faiz Hirani',
	title: 'Software Engineer',
	placeholder: 'testgoomba',
};
